import React from 'react'
const About= ()=> {
    return (
        <div className="my-5">
            <p>Github Finder is an React App  that allows  to find the github users and watch their profile </p>
        </div>
    )
}
export default About
